<script>
/**
 * ****************************************************************************
 * @description     :   Component for popup search certificates
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';
import repository from '@/utils/repository';

/**
 * Define component chat for show page chat
 */
var PopupSearchCertificates = {
    template: template,
    props: {
        onSelected: Function
    },
    data() {
        return {
            search: '',
            resultSearch: []
        };
    },
    methods: {
        doSearch: function () {
            repository
                .get(`popup-search/certificates`, {
                    params: {
                        search: this.search
                    }
                })
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        this.resultSearch = data.Data;
                    } else {
                        this.resultSearch = [];
                    }
                });
        },
        selectFirstRow() {
            if (
                this.resultSearch &&
                this.resultSearch.length > 0 &&
                this.onSelected
            ) {
                this.onSelected(this.resultSearch[0]);
            }
        },
        selectRow(item) {
            if (this.onSelected) {
                this.onSelected(item);
            }
        }
    }
};
export default PopupSearchCertificates;
</script>
